import { useContext } from 'react';
import { TodosWidgetContext } from '../TodosWidgetContext';

export const useTodosWidget = () => {
  const context = useContext(TodosWidgetContext);
  if (!context) {
    throw new Error('useTodosWidget must be used within a TodosWidgetProvider');
  }

  return context;
};
